<div fxLayout="column" fxLayoutAlign="start center">
    <div class="onboarding-completed-container" fxLayout="column" fxLayoutAlign="start center">

        <div class="title">
            {{'Thank you for completing the registration form!'|i18n}}
        </div>

        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="24px">
            <img class="logo margin-0" src="assets/logo_end_onboarding.png" [alt]="'Maps logo'|i18n">
            <div class="subtitle">{{communityName || ''}}</div>
        </div>

        <!-- NO LINKS -->
        <div *ngIf="!webAppUrl && !androidAppUrl && !iosAppUrl && (accessType === MOBILE)"
             class="block" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div class="block-title">
                {{'You are now an active energy community member.'|i18n}}
            </div>
            <div class="img-container" fxLayout="row" fxLayoutAlign="space-around start">
                <img class="coming-soon" alt="coming soon" src="assets/coming_soon.png">
            </div>
        </div>

        <!-- MOBILE APP -->
        <div *ngIf="(!!androidAppUrl || !!iosAppUrl) && accessType === MOBILE"
             class="block" fxLayout="column" fxLayoutAlign="start center">
            <div class="block-title">
                {{'Download app'|i18n}}
            </div>
            <div class="block-subtitle">
                {{'Log in with the e-mail and password you have just chosen'|i18n}}
            </div>
            <div class="img-container" fxLayout="row" fxLayoutAlign="space-around start"
                 fxLayoutGap.lt-sm="30px" fxLayoutGap.lt-md="80px" fxLayoutGap="120px">
                <a *ngIf="iosAppUrl" [href]="iosAppUrl">
                    <img class="badge" alt="download app store logo"
                         [src]="language === 'it' ? 'assets/appstore_badge_ITA.png' : 'assets/appstore_badge_ENG.png'">
                </a>
                <a *ngIf="androidAppUrl" [href]="androidAppUrl">
                    <img class="badge" alt="download play store logo"
                         [src]="language === 'it' ? 'assets/google-play-badge_ITA.png' : 'assets/google-play-badge_ENG.png'">
                </a>
            </div>
        </div>

        <!-- OR -->
        <div *ngIf="!!webAppUrl && (!!androidAppUrl || !!iosAppUrl) && accessType === MOBILE" class="block-separator">
            {{'or'|i18n}}
        </div>

        <!-- WEB APP -->
        <div *ngIf="!!webAppUrl && accessType === MOBILE"
             class="block" fxLayout="column" fxLayoutAlign="start center">
            <div class="block-title">
                {{'Log into web app'|i18n}}
            </div>
            <div class="block-subtitle">
                {{'Log in with the e-mail and password you have just chosen'|i18n}}
            </div>
            <a [href]="webAppUrl" class="mt-35">
                <button class="web-app-btn">
                    {{'Log into web app'|i18n}}
                </button>
            </a>
        </div>

        <!-- ADVANCED MEMBER AND THIRD PARTY PRODUCER -->
        <div *ngIf="!!ctrlUrl && accessType === ADVANCED"
             class="block" fxLayout="column" fxLayoutAlign="start center">
            <div class="block-title">
                {{'Access the web platform'|i18n}}
            </div>
            <div class="block-subtitle">
                {{('Utilize the chosen credentials to log-in'|i18n) + '.'}}
            </div>
            <a [href]="ctrlUrl" class="mt-35">
                <button class="web-app-btn">
                    <span>{{'Access the platform'|i18n}}</span>
                </button>
            </a>
        </div>

        <div class="bottom-subtitle">{{'You will receive updates via e-mail.'|i18n}}</div>
        <div class="bottom-title">{{'Have a good stay'|i18n}}!</div>
    </div>
</div>
